/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_From_DeInputs */

const en_language_from_de = /** @type {(inputs: Language_From_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de_language_from_de = /** @type {(inputs: Language_From_DeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutschen`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {Language_From_DeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const language_from_de = /** @type {((inputs?: Language_From_DeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_From_DeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_language_from_de(inputs)
	return en_language_from_de(inputs)
});